import { useMutation } from '@gogame/query';

import { exportInvoices as source } from 'scenes/FinancialResults/sources/financialResults';

import { exportInvoices as key } from '../queryKeyFactory';

export const useExportInvoices = () => {
  const exportFRMutation = useMutation(key(), source, {
    refresh: false,
    successMessage: () =>
      'You will receive a link to download selected invoice files to your email when ready',
  });

  const handleAction = async (params) => {
    await exportFRMutation.mutateAsync(params);
  };

  return [handleAction, exportFRMutation];
};
